import './static/css/common.css';
import { Button } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input } from 'reactstrap';

const DeleteModal = ({isDeleteModalOpen, setIsDeleteModalOpen, currentItem, handleDelete, isSaving}) => {
  //console.log("DeleteModal: " + JSON.stringify(currentItem));
  if (!currentItem) return;

  const close = () => { if (!isSaving) setIsDeleteModalOpen(false); };

  return (
    <>
    <Modal size="md" isOpen={isDeleteModalOpen} toggle={close}>
      <Form onSubmit={handleDelete}>
      <Input value={currentItem.id} type="hidden" name="id" />
      <ModalHeader toggle={close}>Poista sääntö</ModalHeader>
        <ModalBody>
        Haluatko varmasti poistaa säännön '{currentItem.original}'?
        </ModalBody>
        <ModalFooter>
            <Button type="submit" color="primary" disabled={isSaving}>{isSaving ? "Poistetaan..." : "Poista"}</Button>{' '}
            <Button color="secondary" onClick={close} disabled={isSaving}>Peruuta</Button>
        </ModalFooter>
      </Form>
    </Modal>
    </>
  );
}
export default DeleteModal;
